import React from "react"
import "./blackFriday2026.scss"
import { BF_SHORT_DATE_LABEL } from "config/blackFriday2026"

/**
 * The Black Friday entry of the normal shop's category list (in place of the
 * category icon + name): black BLACK FRIDAY lockup with the red corner,
 * followed by the dates (temp/black-friday/nov4/normal_shop_BF_category.png).
 */
const BfCategoryLabel = () => (
  <span className="bf-catlabel" data-test-id="bfCategoryLabel">
    <span className="bf-catlabel__lockup">
      <i className="bf-catlabel__corner" aria-hidden="true" />
      Black<b>Friday</b>
    </span>
    <span className="bf-catlabel__date">{BF_SHORT_DATE_LABEL}</span>
  </span>
)

export default BfCategoryLabel
